const isInternalLink = link => !(/^[a-zA-Z]+:(?!(\/\/(www\.)?brainbits.net))/).test(link);

export default isInternalLink;
